module.exports = __webpack_public_path__ + "img/num3_active.97f73248.png";